import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase"; // <- dostosuj ścieżkę jeśli trzeba
import { IS_DEMO } from './App';
/* =========================
   VISITOR ID (localStorage)
========================= */
const getVisitorId = () => {
  const key = "visitor_id";
  let id = localStorage.getItem(key);

  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(key, id);
  }

  return id;
};

/* =========================
   TRACKER PROVIDER
========================= */
export default function TrackerProvider({ children }) {
  const location = useLocation();

  useEffect(() => {
    if (!IS_DEMO){return}
    const track = async () => {
      try {
        await addDoc(collection(db, "stats"), {
          visitorId: getVisitorId(),
          path: location.pathname,
          createdAt: serverTimestamp(),
        });
      } catch (err) {
        console.error("Tracker error:", err);
      }
    };

    track();
  }, [location.pathname]);

  return children;
}
